import { createAction } from '@reduxjs/toolkit';

import * as actionTypes from './actionTypes';

export const getAdditionalInformationEntitiesSummaries = createAction<{
  ids: string[];
}>(actionTypes.GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES.BASE);
